"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFortumTuuli = function IconFortumTuuli(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M25.663 6.386c-.202-.82-.892-1.365-1.693-1.365a1.74 1.74 0 0 0-1.716 1.455l-1.202 12.918a5 5 0 0 0-1.961 3.041l-10.747 8.18-.123.106a1.74 1.74 0 0 0 1.829 2.889l11.872-5.473L20.932 43h6.137l-.99-14.862 11.77 5.45.152.053c.81.249 1.645-.076 2.051-.782a1.74 1.74 0 0 0-.435-2.236l-10.731-8.205a5 5 0 0 0-1.939-3.01L25.695 6.543zm-.812 12.128-.874-8.997-.835 8.995a5 5 0 0 1 1.709.002m3.935 6.346a5 5 0 0 1-1.019 1.856l8.74 4.047zm-4.692 3.579h-.188L23.068 41h1.863zm-3.877-1.718a5 5 0 0 1-1.02-1.853L11.45 30.76zm19.86-14.086a3.28 3.28 0 0 0-4.117-.562l-.427.28-.167.1a2.28 2.28 0 0 1-2.7-.335l-.691.723.152.138a3.28 3.28 0 0 0 3.937.22l.353-.231.167-.102a2.28 2.28 0 0 1 2.85.552l.772-.636zm0 3.69a3.28 3.28 0 0 0-4.117-.561l-.427.278-.167.102a2.28 2.28 0 0 1-2.7-.335l-.691.723.152.137a3.28 3.28 0 0 0 3.937.22l.353-.231.167-.102a2.28 2.28 0 0 1 2.85.552l.772-.636zM12.01 12.12a3.28 3.28 0 0 1 3.977.644l.129.147-.772.636a2.28 2.28 0 0 0-2.85-.552l-.167.102-.353.232c-.078.05-.137.086-.208.125a3.28 3.28 0 0 1-3.729-.346l-.152-.138.69-.722a2.28 2.28 0 0 0 2.7.335l.168-.102.427-.278zm3.977 4.334a3.28 3.28 0 0 0-4.117-.561l-.427.278-.167.102a2.28 2.28 0 0 1-2.7-.335l-.691.723.152.137a3.28 3.28 0 0 0 3.937.22l.353-.231.167-.102a2.28 2.28 0 0 1 2.85.552l.772-.636zm6.503 6.985a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m-.5-3a3 3 0 1 1 0 6 3 3 0 0 1 0-6",
    clipRule: "evenodd"
  })));
};

export { IconFortumTuuli, IconFortumTuuli as default };
